export default{
    ActionConstants: {
        UFP_ACTION_ERROR: 'UFP_ACTION_ERROR'
    },
    RequestMethodConstants: {
        GET: 'get',
        DELETE: 'delete',
        PUT: 'put',
        PATCH: 'patch',
        POST: 'post'
    }
}
